import { useEffect } from "react";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";

import Company from "./company";
import Values from "./values";
import Valuation from "./valuation";
import PersonalInfo from "./PersonalInfo";

const StartUp = ({ values, onChange }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const location = window.location.pathname;
    if (!values.company_name && !location.includes("company")) return navigate("/valuation-game/start-up/company");
    if (values.company_name && !values.valuation_game_maturity && !location.includes("values")) return navigate("/valuation-game/start-up/values");
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Navigate to={"./company"} />} />
      <Route path="/company" element={<Company values={values} onChange={onChange} />} />
      <Route path="/values" element={<Values values={values} onChange={onChange} />} />
      <Route path="/valuation" element={<Valuation values={values} onChange={onChange} />} />
      <Route path="/personal-info" element={<PersonalInfo values={values} onChange={onChange} />} />
    </Routes>
  );
};

export default StartUp;
